import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { eachDayOfInterval, format } from 'date-fns'

import TimelineSegment from './TimelineSegment'

import useStyles from './styles'

const InventoryTimeline = React.memo(({ name, conflictDates, startDate, endDate, label }) => {
  const classes = useStyles()

  // Generate all dates in the range for timeline (limited to max 4 months)
  const allDates = useMemo(() => {
    return eachDayOfInterval({ start: startDate, end: endDate })
  }, [startDate, endDate])
  const totalDays = allDates.length

  // Create segments for the timeline bar
  const segments = useMemo(() => {
    const segments = []
    let currentSegment = null

    allDates.forEach((date, index) => {
      const dateStr = format(date, 'yyyy-MM-dd')
      const isUnavailable = conflictDates.includes(dateStr)
      const segmentType = isUnavailable ? 'unavailable' : 'available'

      if (!currentSegment || currentSegment.type !== segmentType) {
        // Start new segment
        if (currentSegment) {
          segments.push(currentSegment)
        }
        currentSegment = {
          type: segmentType,
          startIndex: index,
          endIndex: index,
          dates: [date]
        }
      } else {
        // Extend current segment
        currentSegment.endIndex = index
        currentSegment.dates.push(date)
      }
    })

    // Add the last segment
    if (currentSegment) {
      segments.push(currentSegment)
    }

    return segments
  }, [allDates, conflictDates])

  return (
    <div className={classes.timelineRow}>
      <div className={classes.placementLabel}>{label}</div>
      <div className={classes.timelineBar}>
        {segments.map((segment, index) => (
          <TimelineSegment
            key={index}
            segment={segment}
            index={index}
            name={name}
            totalDays={totalDays}
            classes={classes}
          />
        ))}
      </div>
    </div>
  )
})

InventoryTimeline.propTypes = {
  name: PropTypes.string.isRequired,
  conflictDates: PropTypes.arrayOf(PropTypes.string).isRequired,
  startDate: PropTypes.instanceOf(Date).isRequired,
  endDate: PropTypes.instanceOf(Date).isRequired,
  label: PropTypes.string.isRequired
}

export default InventoryTimeline
